const getters = {
  sidebar: state => state.app.sidebar,
  language: state => state.app.language,
  size: state => state.app.size,
  device: state => state.app.device,
  visitedViews: state => state.tagsView.visitedViews,
  cachedViews: state => state.tagsView.cachedViews,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  introduction: state => state.user.introduction,
  roles: state => state.user.roles,
  roleId: state => state.user.roleId,
  permission_routes: state => state.permission.routes,
  errorLogs: state => state.errorLog.logs,
  club: state => state.club,
  unreadNo: state => state.message.unreadNo,
  is_turnring: state => state.message.is_turnring,
  btnPer: state => state.message.btnPer
}
export default getters
